"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
class Program extends base_model_1.default {
    constructor(data = {
        id: null,
        name: null,
    }) {
        super(data);
        this.name = defaults_1.defaultString(data.name);
    }
}
exports.default = Program;
